import api from "../../services/api";
import Swal from "sweetalert2";

export const descargarJsonsZip = async (fromDate, toDate) => {
  try {
    const response = await api.get("/invoices/descargar-jsons-zip", {
      params: { from: fromDate, to: toDate },
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `jsons_${fromDate}_al_${toDate}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    Swal.fire("Error", "No se pudieron descargar los JSONs", "error");
  }
};